import { ApolloError, gql, useMutation } from "@apollo/client";
import {
  ChangeActiveMutation,
  ChangeActiveMutationVariables,
} from "../generated/graphql";

const CHANGE_ACTIVE_MUTATION = gql`
  mutation changeActive($input: ChangeActiveInput!) {
    changeActive(input: $input) {
      ok
      err
    }
  }
`;

export const useChangeActive = (
  onCompleted?: (data: ChangeActiveMutation) => void,
  onError?: (error: ApolloError) => void
) => {
  return useMutation<ChangeActiveMutation, ChangeActiveMutationVariables>(
    CHANGE_ACTIVE_MUTATION,
    {
      onCompleted,
      onError,
      fetchPolicy: "network-only",
    }
  );
};
